import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {MessageService} from 'primeng/api';
import { isDevMode } from '@angular/core';
import {ConfirmationService} from 'primeng/api';
//import { OfferService } from './offer.service';
import pkg from '../../package.json';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class ApiService {

	fromLink:string = '';

	version = pkg.version;

	pro:boolean = false;

	currentUrl:string;

	blocked = false;

	gameOrders:any = {};

	url: string = "https://admin.blackrockgames.fr/api/index.php?";

	loading:boolean = false;

	user:any;
	
	favs:any;

	offers:any;

	fromGuard = false;

	games:any;

	ebpOffers:any;

	cats:any;
	editors:any;
	
	shippings:any;

	dialogOffers = false;
	
	displayFast =false;

	reductions:any;

	newOrder:any = {
		prods: [],
		customer: {},
		payment: {Id:''},
		DiscountRate : 0,
		DiscountAmount : 0,
		freeShipping : false,
		shipping: 0,
		sumTTC:0,
		sumHT:0,
		offers: [], 
		notes: '',
		deliveryAddress:undefined,
		addressChanged: false,
		devis : true,
		manualOrder: false,
		fromPro: true
	};

	reassorts:any;
	payment:any;
	texts:any;

	order: any;

	adminOrder = false;

	adminUser:any = new BehaviorSubject(undefined);

	reducsDetails:any;
	
	cacheGames:any;

	export = false;

	franco = 250;
	fastOrderQty:any = {};

	// Subject pour notifier les changements de commande
	private orderChangeSubject = new Subject<void>();
	orderChange$ = this.orderChangeSubject.asObservable();

	constructor(private http:HttpClient, private route : Router,private messageService: MessageService, 
		private confirmationService: ConfirmationService){
		this.order = this.newOrder;
		let split = window.location.hostname.split('.');
		if(split[0] == 'espacepro'){
			this.pro = true;
			document.documentElement.style.setProperty('--primary-color', '#9dcc3e');
		}else{
			this.pro = false;
			document.documentElement.style.setProperty('--primary-color', '#3db1e0');
			if(split[0] == 'site-export'){
				this.export = true;
			}
		}
		if(window.location.pathname.indexOf('adminOrder') > -1){
			this.adminOrder = true;
		}else{
			this.adminOrder = false;
		}
		//console.log(this.adminOrder);
	}

	isDevMode(){
		return isDevMode();
	}

	inIframe () {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}

	getAdminUser(){

	}

	crypt(string){
		string += "&v="+this.version; 
		if(isDevMode()){
			return string+"&test=true";
		}else{
			let key = '4564azaz88assasasaForNewBlckkk852222';
			let key2 = 'zerppoqfgETMYjkfstrongbcvhs@';
			string = string.replace(/=/g,key);
			string = string.replace(/&/g,key2);
			return "pc="+btoa(string);
		}
	}


	get(params){
		setTimeout(()=>{this.loading = true;});
		return this.http.get(this.url+this.crypt(params)).toPromise().then((res)=>{
			setTimeout(()=>{this.loading = false;},1000);
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	getEncrypted(params){
		setTimeout(()=>{this.loading = true;});
		return this.http.get(this.url+this.crypt(params)).toPromise().then((res:any)=>{
			setTimeout(()=>{this.loading = false;},1000);
			if(res && res.encrypted){
				return this.decryptResponse(res);
			}
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	decryptResponse(res:any){
		try {
			const key = CryptoJS.enc.Utf8.parse('BRG2026SecureK3y!ProEspaceCrypt!');
			const iv = CryptoJS.enc.Base64.parse(res.iv);
			const decrypted = CryptoJS.AES.decrypt(res.data, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
			return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
		} catch(e) {
			console.error('Decryption error:', e);
			return res;
		}
	}
	
	getJson(file){
		setTimeout(()=>{this.loading = true;});
		return this.http.get(file).toPromise().then((res)=>{
			setTimeout(()=>{this.loading = false;},1000);
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	getHtml(file){
		setTimeout(()=>{this.loading = true;});
		return this.http.get(file, { responseType: 'text' }).toPromise().then((res)=>{
			setTimeout(()=>{this.loading = false;},1000);
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}
	
	post(params,post){
		setTimeout(()=>{this.loading = true;});

		return this.http.post(this.url+this.crypt(params),post).toPromise().then((res)=>{
			setTimeout(()=>{this.loading = false;},1000);
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	postEncrypted(params,post){
		setTimeout(()=>{this.loading = true;});
		return this.http.post(this.url+this.crypt(params),post).toPromise().then((res:any)=>{
			setTimeout(()=>{this.loading = false;},1000);
			if(res && res.encrypted){
				return this.decryptResponse(res);
			}
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	postWS(params,data,load = true){
		if(load)  
			setTimeout(()=>{this.loading = true;});

		return this.http.post("https://ws.blackrockgames.fr/index.php?"+this.crypt(params),data).toPromise().then((res)=>{
			setTimeout(()=>{this.loading = false;},1000);
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	goTo(path){
		this.route.navigate([path]);
	}
	success(mess, life = 3000){
		this.messageService.add({severity:'success', summary:'Succés', detail:mess, life:life});
	}
	info(mess){
		this.messageService.add({severity:'info', summary:'Info', detail:mess});
	}
	error(mess){
		this.messageService.add({severity:'error', summary:'Erreur', detail:mess});
	}
	warning(mess){
		this.messageService.add({severity:'warn', summary:'Attention', detail:mess});
	}

	/**
	 * Revalide rupture / dispo des lignes panier à partir du catalogue frais.
	 * Nécessaire car le panier localStorage peut avoir été sauvé avec d'anciens flags.
	 * @returns les produits devenus indisponibles (rupture)
	 */
	revalidateCartAvailability(){
		const unavailable = [];
		if(!this.order || !this.order.prods || !this.games){
			return unavailable;
		}

		for(let p of this.order.prods){
			if(p.type == 'text' || p.gift){
				continue;
			}

			const game = this.games.find(item => item.Id == p.Id);
			if(!game){
				p.rupture = true;
				p.orderable = false;
				p.inStock = false;
				unavailable.push(p);
				continue;
			}

			p.RealStock = game.RealStock;
			p.force_outstock = game.force_outstock;
			p.out_date = game.out_date;
			p.out_date_date = game.out_date_date;
			p.orderable = game.orderable;
			p.rupture = !!game.rupture;
			p.inStock = !p.rupture;

			// Aligner le panier sur le catalogue : stock bas = ligne rouge (comme chez le commercial)
			if(!p.rupture && game.orderable === false && parseInt(game.RealStock) < 5){
				p.rupture = true;
				p.inStock = false;
			}

			if(p.rupture){
				unavailable.push(p);
			}
		}

		return unavailable;
	}

	log(mess){
		console.log(mess);
	}

	objectValues(array){
		return Object.values(array);
	}

	objectKeys(array){
		return Object.keys(array);
	}

	confirm(mess) {
		return new Promise((resolve, reject) => {
			this.confirmationService.confirm({
				message: mess,
				accept: () => {
					resolve('ok');
				},
				reject: () => {
					resolve('ko');
				}
			});
		});
	}

	bodyOverflow(cl){
		document.body.style.overflowY = cl;
		window.scroll(0,0);
		this.blocked = !this.blocked;
	}

	selectedProduct:any;
	
	addToCart(gameToAdd, fromFile = false){
		let game = Object.assign({}, gameToAdd);

		game.discountRateSupp = game.discountRateSupp || 0;

		game.discountRate = 100 - ((1- (game.discountRateCustomer/100) ) * (1- (game.discountRateSupp/100)) *100);

		let i = this.order.prods.findIndex(item=>item.Id == game.Id && !item.gift);
		
		if(i > -1){
			this.order.prods[i].quantity++;
			this.applySampleCasPart(this.order.prods[i]);
			this.changeQty(this.order.prods[i]);
			this.selectedProduct = game;
			return false;
		}
		game.id = gameToAdd.idInCart = new Date().getTime();		
		game.quantity = game.quantity || 1;
		if(game.qtyInCart && game.qtyInCart > 0)
			game.quantity = game.qtyInCart;
		this.applySampleCasPart(game);
		this.gift(game,fromFile);
		this.order.prods.push(game);
		if(!this.adminOrder)
			this.success("Produit ajouté au panier",1000);
		this.totalOrder();
		this.selectedProduct = game;
		
		// Notifier les changements de produits
		this.notifyOrderChange();
		
		return false;
	}

	/** Cas particulier auto : Group1/Group2 SAMPLE → ECHANTILLON EXPORT */
	applySampleCasPart(prod){
		if(!this.adminOrder || !prod || prod.type == 'text')
			return;
		if(prod.Group1 == 'SAMPLE' || prod.Group2 == 'SAMPLE'){
			prod.lineText = { Id: 'sample', Caption: 'ECHANTILLON EXPORT' };
			prod.sample = true;
		}
	}

	roundToStep(obj: any, qtyProp: string = 'quantity') {
		if (obj.step > 1 && obj[qtyProp] % obj.step !== 0) {
			obj[qtyProp] = Math.round(obj[qtyProp] / obj.step) * obj.step;
		}
	}

	changeQty(prod){
		let time = 100;
		if(prod.quantity > 0){
			time = 0;
		}
		setTimeout(()=>{
			if(prod.quantity === 0){
				if(this.games){
					let i = this.games.findIndex(item => item.idInCart === prod.id);
					if(i > -1){
						let cache = this.cacheGames && this.cacheGames.find(item => item.Id == this.games[i].Id);
						if(cache)
							this.games[i] = this.parse(this.stringify(cache));
					}
				}

				this.order.prods = this.order.prods.filter(item => {
					if(item.id == prod.id){
						return false;
					}
					if(item.parent == prod.id){
						return false;
					}
					return true;
				});
			}else if(!prod.gift){
				this.gift(prod);
			}
			this.totalOrder();
			
			// Notifier les changements de produits
			this.notifyOrderChange();
		},time);

	}

	totalOrder(){
		this.order.sumTTC = 0;
		let sum = 0;
		this.order.FinancialDiscountRate = this.order.customer.FinancialDiscountRate || 0;
		this.order.VatAmount = 0;

		for(let prod of this.order.prods.filter(item=>item.type != 'text')){
			this.applySampleCasPart(prod);
			if(this.order.tva != undefined && prod.Rate > this.order.tva){
				prod.Rate = this.order.tva;
			}
			prod.discountRate = 100 - ((1- (prod.discountRateCustomer/100) ) * (1- (prod.discountRateSupp/100)) *100);
			prod.discountRate = prod.discountRate.toFixed(2)
			prod.discountAmount = (prod.priceHT * prod.discountRate/100);
			var prodTotHT = (prod.priceHT * prod.quantity) - (prod.discountAmount * prod.quantity);
			prod.RealNetAmountVatExcludedWithDiscountAndFinancialDiscount = prodTotHT * (1 - this.order.FinancialDiscountRate/100);
			sum += prodTotHT;
			prod.TotalVatAmount = prod.RealNetAmountVatExcludedWithDiscountAndFinancialDiscount * prod.Rate / 100;
			this.order.VatAmount += prod.RealNetAmountVatExcludedWithDiscountAndFinancialDiscount * prod.Rate / 100;
			if(prod.Id == 'WOG073SJ' && !prod.gift){
				if(prod.quantity > 3){
					//prod.quantity = 3;
				}
			}
		}
		this.order.FinancialDiscountAmount = this.order.sumHT * this.order.FinancialDiscountRate / 100;
		this.order.sumTTC = sum + this.order.VatAmount - this.order.FinancialDiscountAmount;
		this.order.sumHT = sum;
		this.order.DiscountAmount = this.order.sumHT * this.order.DiscountRate / 100;
		this.order.AmountWithFinancialDiscount = this.order.sumHT - this.order.FinancialDiscountAmount - this.order.DiscountAmount + this.order.shipping;
		this.getShipping();
		this.order.prods.sort((a,b)=>{
			return a.id - b.id;
		});
	}


	gift(prod, fromFile = false){
		//reinit
		this.order.prods = this.order.prods.filter(item => {
			if(item.parent && item.parent == prod.id){
				if(item.gift && item.id_offer > 0 && item.quantity > 0){
					let o = this.offers.find(offer => offer.id_offer == item.id_offer);
					if(o)
						o.acceptedForProds.push(item.Id);
				}
				return false;
			}
			return true;
		});

		//reinit
		let baseProd = this.games.find(item => item.Id == prod.Id);
		prod.discountRateSupp = baseProd.discountRateSupp || 0;
		prod.discountRate = 100 - ((1- (prod.discountRateCustomer/100) ) * (1- (prod.discountRateSupp/100)) *100);
		delete prod.offerName;
		//reinit

		for(let offer of this.offers){
			let o = Object.assign({}, offer);
			o.acceptedForProds = o.acceptedForProds ? [...new Set(o.acceptedForProds)] : [];

			if(!prod.authorizedOffers || prod.authorizedOffers.indexOf(o.id_offer) === -1)
				continue;

			if(o.baseQty < 1 && o.field != null){
				o.baseQty = parseInt(prod[o.field]);
				console.log(o.baseQty);
			}
			
			let giftQty = Math.floor(prod.quantity / parseInt(o.baseQty)) * o.giftQty;
			if(giftQty > o.limitedGiftQty && o.limitedGiftQty > 0)
				giftQty = o.limitedGiftQty;

			if(((o.onExactQuantity == '1' && prod.quantity % parseInt(o.baseQty) === 0) || (o.onExactQuantity == '0' && giftQty > 0)) && prod.quantity <= (parseInt(o.baseQty) * o.multiple)){
				let copy = Object.assign({}, prod);
				copy.id = prod.id + 1;
				delete copy.offerId;
				delete copy.qtyToDelete;
				if(o.imposed == '1' || o.acceptedForProds.indexOf(prod.Id) > -1){
					copy.quantity = giftQty;
				}else{
					copy.quantity = 0;
					copy.giftQty = giftQty;
				}		
				copy.parent = prod.id;
				copy.gift = true;
				copy.discountRateSupp = parseFloat(o.discountRate);
				//copy.discountRateCustomer = prod.discountRateCustomer;
				copy.discountRate = 100 - ((1- (copy.discountRateCustomer/100) ) * (1- (copy.discountRateSupp/100)) *100);
				copy.offerName = o.name_offer;
				copy.id_offer = o.id_offer;
				if(o.type == 'add'){
					this.order.prods.push(copy);
					this.totalOrder();
				}
				if(o.type == 'apply'){
					prod.offerName = o.name_offer;
					prod.discountRateSupp += 2;
					prod.discountRate = 100 - ((1- (prod.discountRateCustomer/100) ) * (1- (prod.discountRateSupp/100)) *100);
				}

				if(o.cumulative == '0'){
					break;
				}
			}
		}
		prod.discountRate = parseFloat(prod.discountRate).toFixed(2);
	}

	base64_url_encode(input) {
		// URL-safe: btoa can produce '/' and '+', which break path routes like games/:filter
		return btoa(input).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
	}

	base64_url_decode(input) {
		let s = decodeURIComponent(input).replace(/-/g, '+').replace(/_/g, '/');
		while (s.length % 4) {
			s += '=';
		}
		return atob(s);
	}

	postOrder(data){  
		setTimeout(()=>{this.loading = true;});
		return this.http.post("https://ws.blackrockgames.fr/newOrder.php",data).toPromise().then((res)=>{
			setTimeout(()=>{this.loading = false;},1000);
			return res;
		}).catch(res=>{
			console.log(res);
			this.error(res.statusText || "Une erreur a eu lieu");
			setTimeout(()=>{this.loading = false;},1000);
			return false;
		});
	}

	getShipping(){
		let ShippingId = this.user.ShippingId;
		if(typeof(this.shippings) != "undefined" && this.order.prods.length > 0 && ShippingId != undefined ){
			let last = Object.values(this.shippings[ShippingId]).slice(-1);
			if(this.order.freeShipping){
				this.order.shipping = 0;
			}else{
				var totWeight = 0;
				this.order.prods.forEach(function(prod){
					if(prod.type != 'text')
						totWeight += parseFloat(prod.Weight) * prod.quantity;
				});
				if(this.order.sumHT < this.franco)
					this.order.shipping = parseFloat(this.shippings[ShippingId][Math.ceil(totWeight/1000)] || last);
				else
					this.order.shipping = 0;
			}
		}

		this.order.totWeight = totWeight/1000;
		return this.order.shipping;
	}

	addEbpOffer(offer){
		let o1 = this.games.find(item => item.Id == offer.Id);
		if(o1.qtyInCart === undefined)
			o1.qtyInCart = 1;
		let o = Object.assign({},o1);
		
		//if(o && o.alreadyOrdered === 0 ){
		o1.alreadyOrdered = 1;
		o.gift = true;
		let error = false;
		for(let link of offer.linked){
			let gameToAdd = this.games.find(item => item.Id == link.LinkedItemId);
			if(gameToAdd){
				let game = Object.assign({}, gameToAdd);
				game.discountRateSupp = link.discountRateSupp;
				console.log(o1.qtyInCart);

				game.discountRate = 100 - ((1- (game.discountRateCustomer/100) ) * (1- (game.discountRateSupp/100)) *100);

				game.id = gameToAdd.idInCart = new Date().getTime();		

				game.quantity = parseInt(link.Quantity) * o1.qtyInCart;

				game.offerId = offer.Id;
				game.qtyToDelete = parseInt(link.Quantity) * o1.qtyInCart;

				game.authorizedOffers = game.authorizedOffers.filter(item => item != '1' && item != '3');
				if(link.IsFree === 1)
					game.gift = true

				this.order.prods.push(game);
				if(game.gift != true && game.discountRateSupp === 0){
					this.gift(game);
				}
				this.success("Produit ajouté au panier",1000);
				this.totalOrder();
			}else{
				error = true;
			}
		}
		if(!error){
			this.addToCart(o);
		}else{
			this.error("Une erreur s'est produite lors de l'ajout de l'offre");
		}
		/*}else{
			this.warning("Vous avez déjà bénéficié de cette offre");
		}*/
		return true;
	}

	clearCart(force = false){

		const resetEditFlags = () => {
			// Évite de garder l'en-tête d'un devis précédent sur une nouvelle commande
			delete this.order.edit;
			delete this.order.DocumentNumber;
			delete this.order.ref;
			delete this.order.ThirdOrderNumber;
			delete this.order.DeliveryDate;
			delete this.order.xx_Code_Festival;
			delete this.order.dotation;
			delete this.order.deliveryAddress;
			this.order.addressChanged = false;
			this.order.notes = '';
			this.order.DiscountRate = 0;
			this.order.freeShipping = false;
			this.order.payment = { Id: '' };
			this.order.devis = this.adminOrder ? false : true;
		};

		if(!force){
			this.confirm('Souhaitez-vous réellement vider votre panier ?').then(res=>{
				if(res == 'ok'){
					for(let p of this.order.prods){
						p.quantity = 0;
						this.changeQty(p);
					}
					this.order.prods = [];
					resetEditFlags();
					localStorage.removeItem('brgProOrder');
				}
			});
		}else{

			for(let p of this.order.prods){
				p.quantity = 0;
				this.changeQty(p);
			}
			this.order.prods = [];
			resetEditFlags();
			localStorage.removeItem('brgProOrder');
		}


	}


	returnBtoa(json){
		return this.base64_url_encode(JSON.stringify(json));
	}

	parse(str) {
		let parsed;

		try {
			parsed = JSON.parse(str);
		} catch (error) {
			console.error(error);
		}

		return parsed;
	}

	stringify(str) {
		let stringified;

		try {
			stringified = JSON.stringify(str);
		} catch (error) {
			console.error(error);
		}

		return stringified;
	}

	/**
	 * Notifie les observateurs d'un changement dans la commande
	 */
	notifyOrderChange(): void {
		this.orderChangeSubject.next();
	}
}
